import React, { useEffect, useState } from 'react';
import {
  Router,
  Route,
  Switch,
  useParams
} from 'react-router-dom';
import './App.css';

import PathError from './pages/PathError';
import WidgetGenerator from './widgets/WidgetGenerator';

import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getDesignTokens } from 'AppGlobals';
import { FooterWidget } from 'layout/Footer';
import { TopMenu } from 'layout/TopMenu';
import { createBrowserHistory } from 'history';

var history = createBrowserHistory();

// import { pages } from 'navigation/Pages';

type PageProperties = {
  data: any
}

export const Page: React.FC<PageProperties> = ({ data }) => {

  let params = useParams();
  var i = 0;

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json');
  requestHeaders.set('Cache-Control', 'no-cache');
  requestHeaders.set('Pragma', 'no-cache');
  requestHeaders.set('Expires', '0');

  useEffect(() => {
    fetch(data, { 'headers': requestHeaders })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [])

  var pageElements = <></>;
  if (items["widgets"]) {
    document.title = "Museum of Art and Digital Entertainment: " + data;
    pageElements = items["widgets"].map((pageItem) => {
      params["key"] = "page_" + i++;
      var widget = WidgetGenerator(pageItem.widget)(pageItem.data, params)
      return (
        widget
      );
    });
  }

  return (
    <>
      { pageElements }
    </>
  );
}


export const Pages: React.FC = () => {

  let params = useParams();
  var i = 0;

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [pages, setPages] = useState([]);
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json');
  requestHeaders.set('Cache-Control', 'no-cache');
  requestHeaders.set('Pragma', 'no-cache');
  requestHeaders.set('Expires', '0');

  useEffect(() => {
    fetch("/navigation/pages.json", { 'headers': requestHeaders })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setPages(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [])

  const p = pages["pages"];
  if (p) {
    var i = 0;
      
    var pageElements = p.map((pageItem) => {
      var pushTop = (
        <div className="pushTop"></div>
      );

      var page = (
        <Page key={ i++ } data={ pageItem.dataUrl } />
      );

      var topMenu = (
        <TopMenu/>
      );

      var footerWidget = (
        <FooterWidget />
      )

      return (
        <Route key={ i += 1 } path={ pageItem.url } exact>
          { pageItem.solo ? <></>: topMenu }
          { pageItem.solo ? <></>: pushTop }
          { page }
          { pageItem.solo ? <></>: footerWidget }
        </Route>
        
      );
    });

    return (
      <>
        { pageElements }
      </>
    );
  } else {
    return <></>
  }
}

export const App: React.FC = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  // Update the theme only if the mode changes
  const theme = React.useMemo(() => createTheme(
      getDesignTokens(prefersDarkMode ? "dark" : "light")
    ),
    [
      prefersDarkMode ? "dark" : "light"
    ]
  );

    return (
      <>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router history={ history }>
            <Switch>
              <Pages />
              <Route component={ PathError }>
              </Route>
            </Switch>
          </Router>
        </ThemeProvider>
      </>
    );
}

export default App;
